import axios from 'axios';
import { toast } from 'react-toastify';

export const getModelData = model => dispatch => {
  axios
    .get(`api/v1/${model}`)
    .then(resp => resp.data[model])
    .then(data => {
      dispatch({
        type: 'GET_TYPE_DATA',
        model,
        data,
      });
    })
    .catch(e => {
      toast.error(`Impossible d'obtenir les items`);
    });
};

export const delClients = () => dispatch => {
  dispatch({
    type: 'DEL_CLIENTS',
  });
};

export const delData = (id, model) => dispatch => {
  dispatch({
    type: 'DEL_DATA',
    id,
    model,
  });
};
